import React, { useEffect, useState } from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
// import './Filter/CustomSelect_Bus.css'
import { decodeToken } from "react-jwt";
import { useLocation } from 'react-router-dom';

const CustomSelectButton = (props) => {

  let location = useLocation();
  let path_check = location.pathname;
  const lastSegment = path_check.split("/").pop();

  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const depo_name = decodedToken.depo_name;

  const { IND, filterdata, columnfilters, apiEnd, clearFilters = "" } = props;
  const [loadedOption, setLoadedOption] = useState([]);

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [disableInput, setDisableInput] = useState(false);
  const [disableInputValue, setDisableInputValue] = useState("");
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [isFirstLoad, setIsFirstLoad] = useState(true);



  const appyData = (data) => {
    let res_result = [];

    // decide bucket source based on IND
    if (data.unique_city?.buckets) {
      res_result = data.unique_city.buckets;
    } else if (data.unique_depo?.buckets) {
      res_result = data.unique_depo.buckets;
    }
    const responce = [];

    if (res_result.length !== 0) {
      let newRes = res_result.map(item => ({
        id: (IND === "CITY_INDEX" || IND === "VIN_NUM" || IND === "REG_NUM") ? item.key.city : item.key.route,
        value: (IND === "CITY_INDEX" || IND === "VIN_NUM" || IND === "REG_NUM") ? item.key.city : item.key.route,
        label: (IND === "CITY_INDEX" || IND === "VIN_NUM" || IND === "REG_NUM") ? item.key.city : item.key.route
      }));

      responce.push(...newRes);

      if (props.cty_depo !== undefined && city_name !== "" && IND === "CITY_INDEX") {
        let tmp_arr = city_name.split(",");

        if (tmp_arr.length === 1) {
          setDisableInput(true);
          setDisableInputValue(tmp_arr[0]);
        }

        res_result.forEach((d) => {
          for (let j = 0; j < tmp_arr.length; j++) {
            const valueKey = d.key.city;
            if (tmp_arr[j] === valueKey) {
              responce.push({
                id: valueKey,
                value: valueKey,
                label: valueKey.toString()
              });
            }
          }
        });
      }
    }

    //   const finalOptionsMulti = [{ label: "All", value: "*" }, ...responce];
    //   const finalOptionsForSingle = [...responce];
    //   setLoadedOption(finalOptionsForSingle);

    //   // 👇 Only set default filter if first load
    //   if (isFirstLoad) {
    //     setSelectedOptions([finalOptionsForSingle[0]]);
    //     props.updateFilter([finalOptionsForSingle[0]], IND);
    //     setIsFirstLoad(false);
    //   }
    // };
    // if (apiEnd === "get_all_vin_num" || apiEnd === "get_all_reg_num") {
    //   const finalOptionsMulti = [{ label: "All", value: "*" }, ...responce];
    //   setLoadedOption(finalOptionsMulti);

    //   if (isFirstLoad && finalOptionsMulti.length > 0) {
    //     setSelectedOptions([finalOptionsMulti[0]]);
    //     props.updateFilter([finalOptionsMulti[0]], IND);
    //     setIsFirstLoad(false);
    //   }

    // } else {
    //   const finalOptionsForSingle = [...responce];
    //   setLoadedOption(finalOptionsForSingle);

    //   if (isFirstLoad && finalOptionsForSingle.length > 0) {
    //     setSelectedOptions([finalOptionsForSingle[0]]);
    //     props.updateFilter([finalOptionsForSingle[0]], IND);
    //     setIsFirstLoad(false);
    //   }
    // }
    //   if (apiEnd === "get_all_vin_num" || apiEnd === "get_all_reg_num") {
    //   const finalOptionsMulti = [{ label: "All", value: "*" }, ...responce];
    //   setLoadedOption(finalOptionsMulti);

    //   // Default selection on first load
    //   if (isFirstLoad && finalOptionsMulti.length > 0) {
    //     setSelectedOptions([finalOptionsMulti[0]]);
    //     props.updateFilter(["*"], IND);  // ← only value "*" not whole object
    //     setIsFirstLoad(false);
    //   }

    // } else {
    //   const finalOptionsForSingle = [...responce];
    //   setLoadedOption(finalOptionsForSingle);

    //   // Default selection on first load
    //   if (isFirstLoad && finalOptionsForSingle.length > 0) {
    //     setSelectedOptions([finalOptionsForSingle[0]]);
    //     props.updateFilter([finalOptionsForSingle[0].value], IND);
    //     setIsFirstLoad(false);
    //   }
    // }
    if (apiEnd === "get_all_vin_num" || apiEnd === "get_all_reg_num") {
      const finalOptionsMulti = [{ label: "All", value: "*" }, ...responce];
      setLoadedOption(finalOptionsMulti);

      if (isFirstLoad && finalOptionsMulti.length > 0) {
        // setSelectedOptions([finalOptionsMulti[0]]);
        // props.updateFilter(["*"], IND);   // sending only the value
        setIsFirstLoad(false);
      }
    } else {
      const finalOptionsForSingle = [...responce];
      setLoadedOption(finalOptionsForSingle);

      if (isFirstLoad && finalOptionsForSingle.length > 0) {
        // setSelectedOptions([finalOptionsForSingle[0]]);
        // props.updateFilter([finalOptionsForSingle[0].value], IND);  // sending value
        setIsFirstLoad(false);
      }
    }


  };
  useEffect(() => {
    // Prevent calling route and depo APIs without a city
    if ((apiEnd === "route" || apiEnd === "depo") && (!filterdata.CITY || filterdata.CITY.length === 0)) {
      return;
    }

    // Clone existing filterdata
    let filterPayload = {
      ...filterdata,
      CITY: filterdata.CITY?.map(item => item.value) || [],
      DEPO: filterdata.DEPO?.map(item => item.value) || []
    };

    // If ROUTE selected — add or update
    if (filterdata.ROUTE_INDEX?.length > 0) {
      filterPayload.ROUTE = [filterdata.ROUTE_INDEX[0].value];
    }

    // If DEPO selected — add or update
    if (filterdata.Depo?.length > 0) {
      filterPayload.DEPO = [filterdata.Depo[0].value];
    }


    fetchData(
      {
        url: API_URL_MAIN + `mileage_sarathi_ace_overview/${apiEnd}`,
        body: {
          IND,
          filterdata: filterPayload,
          columnfilters,
        },
      },
      appyData
    );

  }, [filterdata, clearFilters, apiEnd]);

  useEffect(() => {
    if (IND === "DEPO_INDEX") {
      setSelectedOptions([]);
      props.updateFilter([], IND);
    }
  }, [filterdata.CITY]);

  useEffect(() => {
    setSelectedOptions([]);
  }, [apiEnd]);


  function getDropdownButtonLabelMulti({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `All`;
    } else {
      return `${value.length} selected`;
    }
  }

  function getDropdownButtonLabelForSingle({ placeholderButtonLabel, value }) {
    if (!value.label) {
      return placeholderButtonLabel || 'Select...';
    }

    // if (!value.label) {
    //   return "";
    // }
    return value.label;
  }

  function onChangeMulti(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      setSelectedOptions(loadedOption);
      props.updateFilter(loadedOption, IND);
    } else if (event.action === "deselect-option" && event.option.value === "*") {
      setSelectedOptions([]);
      props.updateFilter([], IND);
    } else if (event.action === "deselect-option") {
      const re = value.filter((o) => o.value !== "*");
      setSelectedOptions(re);
      props.updateFilter(re, IND);
    } else if (value.length === loadedOption.length - 1) {
      setSelectedOptions(loadedOption);
      props.updateFilter(loadedOption, IND);
    } else {
      setSelectedOptions(value);
      props.updateFilter(value, IND);
    }
  }

  function onChangeSingle(selectedOption) {
    if (!selectedOption) {
      props.updateFilter([], IND); // handle clear
    } else {
      props.updateFilter([selectedOption], IND);
    }

    setSelectedOptions(selectedOption);
  }


  const isMultiSelect = (apiEnd === "get_all_vin_num" || apiEnd === "get_all_reg_num");

  // return (
  //   <>
  //     <span className="select_col_title_ace">{props.lable}</span>
  //     {(disableInput) ?
  //       <input autoComplete="off" className="top-filter filter-col" value={disableInputValue} disabled />
  //       :
  //       <ReactMultiSelectCheckboxes className="react-select-container" classNamePrefix="react-select"
  //         style={{ dropdownButton: { width: "100%" } }}
  //         options={[...loadedOption]}
  //         placeholderButtonLabel={props.lable}
  //         isMulti={isMultiSelect}
  //         getDropdownButtonLabel={isMultiSelect ? getDropdownButtonLabelMulti : getDropdownButtonLabelForSingle}
  //         value={selectedOptions}
  //         onChange={isMultiSelect ? onChangeMulti : onChangeSingle}
  //         setState={setSelectedOptions}
  //         disabled={disableInput}
  //       />
  //     }
  //   </>
  // )


  return (
    <>
      <span
        className="select_col_title_ace"
        style={{ color: "#358696", fontWeight: "bold", textAlign: "left", display: "block" }}
      >
        {props.lable}
      </span>
      {disableInput ? (
        <input
          autoComplete="off"
          className="top-filter filter-col"
          value={disableInputValue}
          disabled
        />
      ) : (
        <ReactMultiSelectCheckboxes
          className="react-select-container"
          classNamePrefix="react-select"
          style={{ dropdownButton: { width: "100%" } }}
          options={[...loadedOption]}
          placeholderButtonLabel={props.lable}
          isMulti={isMultiSelect}
          getDropdownButtonLabel={
            isMultiSelect
              ? getDropdownButtonLabelMulti
              : getDropdownButtonLabelForSingle
          }
          value={selectedOptions}
          onChange={isMultiSelect ? onChangeMulti : onChangeSingle}
          setState={setSelectedOptions}
          disabled={disableInput}
        />
      )}
    </>
  );
  


}

export default CustomSelectButton;
